import { z } from 'zod';
import { STORED_TX_TYPES } from './consts';

/**
 * 트랜잭션 타입의 zod 스키마. 값 목록은 `./consts`에 있다(에이전트가 zod 없이 읽는다).
 * 설명은 그쪽 주석을 볼 것.
 *
 * 받는 값은 `STORED_TX_TYPES`다. 28회차에 `TX_TYPES`와 하나로 합쳐 여섯이고, 에이전트도
 * `slow`까지 붙인다. 저장된 행과 조회 조건이 이 스키마를 지난다.
 */
export const TxType = z.enum(STORED_TX_TYPES);
export type TxType = z.infer<typeof TxType>;
